import useSWR from "swr";
import { API_BASE_URL } from "@/lib/env";
import type { BillingPlanResponse } from "@/api/client";

export function useBillingPlan() {
  const { data, error, isLoading, mutate } = useSWR<BillingPlanResponse>(
    `${API_BASE_URL}/me/billing/plan`,
  );

  return {
    plan: data ?? null,
    isLoading,
    isError: !!error,
    refreshPlan: mutate,
  };
}
